"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {removeClass, addClass, on, find, hasClass, findIn} from '@elements/dom-utils';

export function init () {
    onFind('.js-search-overlay__toggle', function (toggler) {
        on('click', function (evt) {
            let overlay = find('.js-search-overlay__overlay');
            let input = find('.js-search-overlay__input');

            if (hasClass('is-open', overlay)) {
                removeClass('is-open', overlay);
                removeClass('is-open', toggler);
            } else {
                addClass('is-open', overlay);
                addClass('is-open', toggler);
                focusInput(input);
            }
        }, toggler)
    });
}

function focusInput(input) {
    // iOS needs focusing directly in the click event
    input.focus();

    let timeout = setTimeout(function () {
        /* timeout is needed because some browsers don't allow focusing a element
        if it is not visible */
        input.focus();
        clearTimeout(timeout);
    }, 500);
}
